import React from 'react';
import { Countdown } from './Countdown';
import { PlanSelector } from './PlanSelector';
export function Pricing() {
  return <section id="precios" aria-labelledby="pricing-title" className="scroll-mt-12" data-id="element-217" data-mp="2aqj1t8pryoee">
      <div className="mx-auto max-w-5xl px-4 py-12 md:px-5 md:py-20" data-id="element-218" data-mp="2ohnyc1xuj0ki">
        <div className="mx-auto max-w-xl rounded-2xl bg-plum p-4 ring-1 ring-line" data-id="element-219" data-mp="2jjw8ddgrhoiy">
          <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-220" data-mp="1vu1v4usj5xy6">
            <div data-id="element-221" data-mp="1rsyei62nrxvw">
              <p className="flex items-center justify-center gap-2 text-sm font-semibold text-blood sm:justify-start" data-id="element-222" data-mp="1rthz5ujp10dm">
                <span className="relative flex h-2.5 w-2.5" aria-hidden="true" data-id="element-223" data-mp="25tsqszstuizu">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-blood opacity-60 motion-reduce:hidden" data-id="element-224" data-mp="20s3bv92hhl6h" />
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-blood" data-id="element-225" data-mp="3h9hczoy9bdzl" />
                </span>
                Oferta en vivo · termina en
              </p>
              <p className="mt-1 text-sm text-mist" data-id="element-226" data-mp="3vyx9k642cai7">
                <span className="font-semibold text-pumpkin" data-id="element-227" data-mp="4svxpvc9xcvi">+$10.000 después</span> — y no vuelve a bajar
              </p>
            </div>
            <Countdown variant="compact" data-id="element-228" data-mp="9tjsms3midv0" />
          </div>
          <div className="mt-3" data-id="element-229" data-mp="er1yg9mcgcys">
            <div className="flex justify-between text-xs font-semibold" data-id="element-230" data-mp="eq0knxdy1cdd">
              <span className="text-mist" data-id="element-231" data-mp="3d9h557p9bxwi">Cupos restantes</span>
              <span className="text-pumpkin" data-id="element-232" data-mp="3d74fe8d9cj8w">68% TOMADOS</span>
            </div>
            <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-night" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados" data-id="element-233" data-mp="3i8bn67fehifk">
              <div className="h-full w-[68%] rounded-full bg-pumpkin" data-id="element-234" data-mp="3ryn20p0mhc18" />
            </div>
          </div>
        </div>

        <div className="mt-8 text-center" data-id="element-235" data-mp="2ui7ngb5c22tu">
          <h2 id="pricing-title" className="font-display text-3xl font-bold text-bone md:text-4xl" data-id="element-236" data-mp="2zh0zs08vvnsf">Elegí tu Megapack de Halloween</h2>
          <p className="mt-1.5 text-sm text-mist md:text-base" data-id="element-237" data-mp="2rfjvpd4bymm3">Las dos opciones incluyen los 3 tomos extra completos</p>
        </div>

        <div className="mt-7" data-id="element-238" data-mp="2mfxjn708ncev">
          <PlanSelector groupName="plan-principal" data-id="element-239" data-mp="3177gwwaan7f4" />
        </div>
      </div>
    </section>;
}